import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";
import { Trans } from "@lingui/react/macro";

import { Metadata } from "@/common/components/metadata/metadata";
import { PageTitle } from "@/common/components/page-title/page-title";

import { TwoColumnLayout } from "../layout/layout";
import { MarketChat } from "./components/market-chat";

const path = "market-ai";

const MarketAi = () => {
  const { _ } = useLingui();

  return (
    <TwoColumnLayout
      left={{
        content: (
          <div className="flex h-full flex-col">
            <Metadata title={_(msg`AI Analýza trhu`)} />
            <MarketChat />
          </div>
        ),
        header: (
          <PageTitle>
            <Trans>AI Analýza trhu</Trans>
          </PageTitle>
        ),
      }}
      right={false}
    />
  );
};

export { MarketAi, path };
